

export const TireSearchResults = () => {

    return (
        <div className="w-full">
            <div className="w-full fixed top-30 z-[9999] flex items-center justify-end gap-6 p-2 bg-white border-y">
                <span className="text-sm font-semibold text-black">Book service:</span>
                <div className="border-r px-1 py-2">
                    <span className="text-sm font-medium text-black">Volvo 2025 XC60</span>
                </div>
                <div className="border-r px-1 py-2">
                    <span className="text-sm font-medium text-black">Tire</span>
                </div>
                <div className="border-r px-1 py-2">
                    <span className="text-sm font-medium text-black">11/20/2025</span>
                </div>
                <button className="bg-primary hover:bg-orange-600 text-white text-sm py-3 px-8 rounded-[70px] font-medium transition">
                    Change
                </button>
            </div>
            <div className="w-full bg-gray-100 min-h-screen pt-20 pb-4 px-10 flex justify-between">
                <div className="w-[25%] bg-white rounded-md p-3">
                    <div className="text-sm text-black font-semibold border-b py-2">
                        Filters
                    </div>
                    <div className="w-full space-y-4 py-4">
                        <div className="rounded-md h-10 bg-gray-200" />
                        <div className="rounded-md h-10 bg-gray-200" />
                        <div className="rounded-md h-10 bg-gray-200" />
                        <div className="rounded-md h-10 bg-gray-200" />
                        <div className="rounded-md h-10 bg-gray-200" />
                        <div className="rounded-md h-10 bg-gray-200" />
                        <div className="rounded-md h-40 bg-gray-200" />
                    </div>
                </div>

                {/* <div className="w-full p-4 flex flex-col items-center space-y-8">
                    <TireDetailCard page="search" />
                    <TireDetailCard page="search" />
                    <TireDetailCard page="search" />
                    <TireDetailCard page="search" />
                    <TireDetailCard page="search" />
                    <TireDetailCard page="search" />
                    <TireDetailCard page="search" />
                    <TireDetailCard page="search" />
                    <TireDetailCard page="search" />
                    <TireDetailCard page="search" />
                </div> */}
            </div>
        </div>
    )
}